import { render, staticRenderFns } from "./basicinfo.vue?vue&type=template&id=5dd40377&scoped=true&"
import script from "./basicinfo.vue?vue&type=script&lang=js&"
export * from "./basicinfo.vue?vue&type=script&lang=js&"
import style0 from "./basicinfo.vue?vue&type=style&index=0&id=5dd40377&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd40377",
  null
  
)

export default component.exports